export default __webpack_public_path__ + "static/media/report_builder_not_found.c0a2a4ec.svg";